import axios from "axios";
import { IAddEventSchedules } from "../../../Models/Event/IAddEventSchedules";
import { IAddTeacherToLesson } from "../../../Models/Event/IAddTeacherToLesson";
import { IEventSchedule } from "../../../Models/Event/IEventSchedule";
import { IEventScheduleList } from "../../../Models/Event/IIEventScheduleList";
import { IUpdateAttendeeOnLesson } from "../../../Models/Event/IUpdateAttendeeOnLesson";
import { IUpdateEventSchedules } from "../../../Models/Event/IUpdateEventSchedules";
import { IUpdateTeacherOnLesson } from "../../../Models/Event/IUpdateTeacherOnLesson";
import { ITeacherLessonsByMonth } from "../../../Models/Reports/ITeacherLessonsByMonth";
import { IResult } from "../../../Models/Result/IResult";
import { Result } from "../../../Models/Result/Result";
import { dateToStr, strToDate } from "../../../Tools/DateTime";
import { formatUrl, handleError } from "../ApiHelpers";
import { IEventSchedulesApi } from "./IEventSchedulesApi";

export class EventSchedulesApi implements IEventSchedulesApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getEventSchedules(eventId: number): Promise<IResult<IEventScheduleList[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/getEventSchedules/${eventId}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IEventScheduleList[]>;

            if (result.isSuccess && result.data) {
                result.data.forEach(function (part, index) {
                    if (result.data) {
                        var d = result.data[index].dateString;
                        if (d) {
                            result.data[index].date = strToDate(d);
                            result.data[index].key = result.data[index].id;
                        }
                        else {
                            return Result.Fail<IEventScheduleList[]>(-1, "Datum je undefined");
                        }

                    }
                }, result.data);
                return Result.ok(result.data);
            }
            return result;
        }
        catch (error) {
            return handleError(error, "getEventSchedules");
        }
    }

    async getEventSchedule(eventId: number, id: number): Promise<IResult<IEventSchedule>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/getEventSchedule/${eventId}?Id=${id}`);
            const response = await axios.get(url);
            var result = response.data as IResult<IEventSchedule>;

            if (result.isSuccess && result.data) {
                const d = result.data.dateString;

                if (d) {
                    result.data.date = strToDate(d);
                }
                else {
                    return Result.Fail<IEventSchedule>(-1, "Datum je undefined");
                }
                return Result.ok(result.data);
            }
            return result;
        }
        catch (error) {
            return handleError(error, "getEventSchedule");
        }
    }

    async addEventSchedule(eventSchedule: IAddEventSchedules): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/AddEventSchedule`);
            const response = await axios.post(url, eventSchedule);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "addEventSchedule");
        }
    }

    async udateEventSchedule(eventSchedule: IUpdateEventSchedules): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/UpdateEventSchedule`);
            const response = await axios.post(url, eventSchedule);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "udateEventSchedule");
        }
    }

    async removeEventSchedule(eventId: number, id: number): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/RemoveEventSchedule/${eventId}?id=${id}`);
            const response = await axios.delete(url);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "removeEventSchedule");
        }
    }


    async addTeacherToLesson(t: IAddTeacherToLesson): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/addTeacherToLesson`);
            const response = await axios.post(url, t);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "addTeacherToLesson");
        }
    }

    async updateTeacherToLesson(t: IUpdateTeacherOnLesson): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/updateTeacherToLesson`);
            const response = await axios.post(url, t);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "updateTeacherToLesson");
        }
    }

    async removeTeacherFromLesson(eventId: number, id: number, teacherId: number): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/removeTeacherFromLesson?eventId=${eventId}&id=${id}&teacherId=${teacherId}`);
            const response = await axios.delete(url);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "removeTeacherFromLesson");
        }
    }

    async updateAttendeeOnLesson(attendee: IUpdateAttendeeOnLesson): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/updateAttendeeOnLesson`);
            const response = await axios.post(url, attendee);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "updateAttendeeOnLesson");
        }
    }

    async reportTacherLessonsByMonth(month: number, year: number): Promise<IResult<ITeacherLessonsByMonth[]>> {

        try {
            const url = formatUrl(this.backendUrl, `/api/EventSchedule/ReportTeacherLessonsByMonth?month=${month}&year=${year}`);
            const response = await axios.get(url);
            return response.data as IResult<ITeacherLessonsByMonth[]>;
        }
        catch (error) {
            return handleError(error, "reportTacherLessonsByMonth");
        }
    }
}
